import React, { useState, useEffect, useMemo } from 'react'
import { filter } from 'underscore';
import { Flex, Tabs } from 'antd-mobile';

import { Loading } from '../components';
import { CustomerFilter } from '../components/CommonFilter';
import { CountryFilter } from '../components/CountryFilter';
import { Radios } from '../components';

import { PurposeNumber, MaxPage } from '../utils/const';
import { GetCustomerPaidConfigList, GetBillIdList } from '../../../api/order';

import DiscountList from './DiscountList';
import DiscountConfigForm from './DiscountConfigForm';
import InnerDiscountConfigForm from './InnerDiscountConfigForm';

const SelectPurpose = { ...PurposeNumber };
// delete SelectPurpose[5];

const tabs = [
  { title: '配置查询' },
  { title: '配置内部折扣' },
  { title: '配置客户折扣' },
];

export const CNBrevityCode = 'CN';

export default function DiscountConfig({ CompanyInfo, ChargeType }) {
  const isWhatsApp = false;

  const [purpose, setPurpose] = useState();
  const [loading, setLoading] = useState(false);
  const [AccountId, setAccountId] = useState();
  const [BrevityCode, setBrevityCode] = useState();

  const [filterValues, setFilterValues] = useState({});
  const [foreignList, setForeignList] = useState([]);
  const [foreignFilterList, setForeignFilterList] = useState([]);

  // const [, setListParams] = useState();
  const [billIdList, setBillIdList] = useState([]);
  const [defaultConfigList, setDefaultConfigList] = useState([]);

  const [tab, setTab] = useState(0);

  // 前端搜索
  const filterList = (filters, foreignList) => {
    setFilterValues(filters);
    const checkAccountId = (item) =>
      filters.AccountId && filters.AccountId.length > 0 ? filters.AccountId.includes(item.AccountId) : true; // 多选
    const checkBrevityCode = (item) => filters.BrevityCode && filters.BrevityCode.length > 0 ? (filters.BrevityCode.includes('EN') || filters.BrevityCode.includes(item.BrevityCode)) : true; // 多选
    const checkSmsType = (item) => filters.Purpose ? +item.Purpose === +filters.Purpose : true; // 单选
    const checkConversationType = (item) =>
      filters.ConversationType ? item.ConversationType === filter.ConversationType : true; // 单选

      const foreignFilterList = foreignList.filter(
      (item) =>
        checkAccountId(item) &&
        checkBrevityCode(item) &&
        (isWhatsApp ? checkConversationType(item) : checkSmsType(item))
    );

    // 按照生效时间倒序排列
    foreignFilterList.sort((prev, next) => next.ValidStartTime - prev.ValidStartTime);
    setForeignFilterList(foreignFilterList);
  };

  const getFormatList = (list) => {
    const data = [...list];

    // 按结束时间正序
    data.sort((a, b) => a.ValidEndTime - b.ValidEndTime);
    return data;
  };

  const getList = (params) => {
    if (CompanyInfo && CompanyInfo.CompanyId) {
      // setListParams(params);
      const data = {
        ...params,
        CompanyIds: [+CompanyInfo.CompanyId],
        DomesticFlag: 'Foreign',
        ChargeType,
        Timing: -1,
      };
      setLoading(true);
      GetCustomerPaidConfigList(data).then((res) => {
        // setConfigList(res.Data || []); // 非标配置
        // 非标和默认合并，但区分国内外
        const data = getFormatList(res.Data || []);
        const foreignList = data.filter((item) => item.BrevityCode !== CNBrevityCode);
        setForeignList(foreignList);
        // 有筛选条件的话进行筛选
        filterList(filterValues, foreignList);
        setLoading(false);
      });
    }
  };
  
  const DiscountConfigCallback = (data) => {
    setDefaultConfigList(data)
  }

  const getBillIdList = () => {
    const data = {
      DomesticFlag: 0,
      ChargeType,
      Limit: MaxPage,
    };
    GetBillIdList(data).then((res) => {
      if (res && res.RetCode === 0) {
        setBillIdList(res.Data || []);
      }
    });
  };

  const accountIdOptions = useMemo(() => (CompanyInfo && CompanyInfo.AccountInfo) || [], [CompanyInfo]);

  const editCallback = () => {
    setTab(0);
    setFilterValues({});
    getList();
  }

  useEffect(() => {
    getBillIdList();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getList();
  }, [CompanyInfo]);

  return (
    <Tabs tabs={tabs}
      page={tab}
      tabBarPosition={'top'}
      swipeable={false}
      destroyInactiveTab
      onTabClick={(tab, index) => {
        // if (info.Id === undefined || info.Id === null) { Toast.info('请先选择正确的通道信息') }
        setTab(index);
      }}
    >
      <Flex direction='column'>
        <Flex.Item style={{ marginTop: '8px', marginBottom: "4px", width: '100%' }}>
          <span>短信类型：</span>
          <Radios
            value={purpose}
            style={{ whiteSpace: 'nowrap' }}
            onChange={value => {
              setPurpose(value);
              filterList(Object.assign(filterValues, { Purpose: value }), foreignList);
            }}
            options={Object.keys(SelectPurpose).map(item => ({ label: SelectPurpose[item], value: item }))} />
        </Flex.Item>
        <Flex.Item style={{ marginTop: '12px', width: '100%' }}>
          <CustomerFilter options={accountIdOptions} value={AccountId} onChange={v => {
            setAccountId(v);
            filterList(Object.assign(filterValues, { AccountId: v }), foreignList);
          }} />
        </Flex.Item>
        <Flex.Item style={{ marginTop: '12px', width: '100%' }}>
          <CountryFilter value={BrevityCode} onChange={v => {
            setBrevityCode(v);
            filterList(Object.assign(filterValues, { BrevityCode: v }), foreignList);
          }} />
        </Flex.Item>
        <Loading loading={loading} style={{ marginTop: '12px', width: '100%' }}>
          <DiscountList loading={loading} list={foreignFilterList} billIdList={billIdList} onChange={() => filterList(filterValues, foreignList)} />
        </Loading>
      </Flex>

      <InnerDiscountConfigForm
        ChargeType={ChargeType}
        accountIdOptions={accountIdOptions}
        CompanyId={CompanyInfo.CompanyId}
        callback={editCallback}
        defaultConfigList={defaultConfigList}
        foreignFilterList={foreignFilterList}
      />

      <DiscountConfigForm DiscountConfigCallback={DiscountConfigCallback} ChargeType={ChargeType} accountIdOptions={accountIdOptions} CompanyId={CompanyInfo.CompanyId} callback={editCallback} />
    </Tabs>
  )
}
